var _rect, _circle, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 1.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "21 15 16 10 5 21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotIcon);
export default __webpack_public_path__ + "static/media/screenshot-icon.a40b551d24eb81df9b7b399850014ce1.svg";
export { ForwardRef as ReactComponent };